import React from 'react'
import Traduction from 'Components/Traduction'
import Select from 'Components/Select'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const p = { ...props }
    /*if (props.type_entite_information !== undefined && props.type_entite_information !== '') {
      p.type_entite_information = JSON.parse(p.type_entite_information)
    }*/
    const newState = {
      ...p,
      defaultTypeEntite: p.type_entite_information || [],
      key: Utils.getRandomNumber(),
      action: props.action,
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getInfoTiersDonnees()
    }
  }

  getInfoTiersDonnees = async () => {
    const result = await ApiRequest(project.api + 'crm', {
      requete: 'info_tiers_donnees',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        information_tiers_id: result.results.information_tiers_id,
        //type_entite_information: JSON.parse(result.results.type_entite_information),
        //qualites: result.results.qualites,
        actif: result.results.actif,
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = _ => {
    this.setState({
      defaultLibelle: undefined,
      libelle: undefined,
      type_entite_information: this.props.type_entite_information !== undefined && this.props.type_entite_information !== '' && JSON.parse(this.props.type_entite_information) || [],
      qualites: this.props.qualites,
      actif: this.props.actif,
      key: Utils.getRandomNumber()
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'crm', {
      requete: 'info_tiers_donnees',
      action: action === 'update' && 'update' || 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      information_tiers_id: this.state.information_tiers_id,
      type_entite_information: this.state.type_entite_information,
      qualites: this.state.qualites,
      actif: this.state.actif,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'crm', {
      requete: 'info_tiers_donnees',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          title={EurestoI18n.t('commun:Nom')}
          onChange={this.onChangeState}
          name={'libelle'}
          disabled={disabled}
          data={this.state.libelle !== undefined ? this.state.libelle : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        {/*<Select
          title={EurestoI18n.t('commun:Entité')}
          name="type_entite_information"
          multiple={true}
          disabled={disabled}
          options={Constants.usefullObjectStatic[Constants.donnee.info_tiers].entite
            .filter(o => o.condition ? o.condition() : true)
            .filter(o => this.state.defaultTypeEntite.length === 0 || this.state.defaultTypeEntite.indexOf(o.id) !== -1)
            .map(o => ({
              label: o.libelle,
              value: o.id
            }))}
          value={this.state.type_entite_information !== undefined ? this.state.type_entite_information : []}
          onChange={this.onChangeState}/>

        <DataComponent
          //key={this.state.restateKeyQualite}
          title={EurestoI18n.t('commun:Qualite')}
          name="qualite"
          disabled={disabled}
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.onChangeState}
          data={this.state.qualites}
          object={Constants.donnee.qualite}
          module={Constants.module.CRM}
          search={this.state.type_entite_information !== undefined ? { type: { contains: this.state.type_entite_information } } : {}}
        />
          */}

        {User.TypeAccess.get(Constants.access.EURESTO) && <Select
          title={EurestoI18n.t('commun:Accessible pour...')}
          name="actif"
          disabled={disabled}
          options={[
            {
              label: EurestoI18n.t('commun:Tous'),
              value: 1
            },
            {
              label: EurestoI18n.t('commun:Seulement Euresto'),
              value: 2
            },
            {
              label: EurestoI18n.t('commun:Tous sauf Euresto'),
              value: 3
            }
          ]}
          value={this.state.actif !== undefined ? this.state.actif : 1} onChange={this.onChangeState}/>}
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.props.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouvelle valeur du critère [' + (this.state.information_tiers_id && Data.get(Constants.module.CRM, Constants.donnee.info_tiers, { id: this.state.information_tiers_id }) && Data.get(Constants.module.CRM, Constants.donnee.info_tiers, { id: this.state.information_tiers_id }).libelle || '') + ']')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/CRM/InfoTiersDonnees.js